import React from 'react';
import ImageIcon from './ImageIcon';


export default function Heart() {
  return (
    <ImageIcon small src="/heart.png" />
  );
}
